"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasetTableColumn = void 0;
// export type DatasetTableColumnHeader<T> = (dataset: T[]) => React.ReactNode;
// export type DatasetTableColumnCell<T> = (item: T, dataset?: T[]) => React.ReactNode;
/**
 * All dataset table columns are of this type.
 *
 * We describe a heading and cell that must be a React node or a function
 * that returns a React node.
 */
var DatasetTableColumn = /** @class */ (function () {
    function DatasetTableColumn(configuration) {
        if (configuration === void 0) { configuration = {}; }
        this.cellProps = configuration.cellProps;
        this.headingCellProps = configuration.headingCellProps;
    }
    return DatasetTableColumn;
}());
exports.DatasetTableColumn = DatasetTableColumn;
//# sourceMappingURL=DatasetTableColumn.js.map